import {PortalType} from "@studyportals/domain-client";
import {useRuntimeConfig} from "nuxt/app";

export const getPortalTypeFromEnvClient = (): PortalType => {
	const runtimeConfig = useRuntimeConfig();
	const portalTypeStr = (runtimeConfig.public.portalType as string) || 'master';

	const portalTypeMap: Record<string, PortalType> = {
		'master': PortalType.MASTER,
		'bachelor': PortalType.BACHELOR,
		'phd': PortalType.PHD,
		'short': PortalType.SHORT,
		'distance_learning': PortalType.DISTANCE_LEARNING,
	};

	return portalTypeMap[portalTypeStr.toLowerCase()] || PortalType.MASTER;
};
